// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, HasPagingParameters, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel, PaginationModel, QuoteModel } from "@insite/client-framework/Types/ApiModels";

const quotesUrl = "/api/mcmc/quote";

export interface CustomQuoteCollectionModel extends BaseModel {
    pagination: PaginationModel | null;
    quotes: CustomQuoteModel[] | null;
}

export interface CustomQuoteModel {
    purchaseOrder: string;
    quoteNumber: string;
    status: string;
    requestedDate: string;
    expirationDate: string;
    requestedBy: string;
    customer: string;
    address: {
        addressOne: string;
        addressTwo: string;
        addressThree: string;
        addressFour: string;
        city: string;
        state: string;
        postalCode: string;
    };
}

export interface CustomGetQuotesApiParameter extends ApiParameter, HasPagingParameters {
    status?: string;
    purchaseOrder?: string;
    quoteNumber?: string;
    fromDate?: string;
    toDate?: string;
}

export async function getQuotes(getQuotesParameter: CustomGetQuotesApiParameter) {
    const quotes = await post<CustomGetQuotesApiParameter, CustomQuoteCollectionModel>(
        `${quotesUrl}/quotes`,
        getQuotesParameter,
    );
    return quotes;
}

export async function getQuote(quoteNumber: string) {
    const quote = await get<QuoteModel>(`${quotesUrl}/${quoteNumber}`);
    quote.properties.quoteId = quote.id;
    quote.id = quote.quoteNumber;
    quote.cartLines = quote.quoteLineCollection;
    return quote;
}

export async function declineQuote(quoteNumber: string) {
    const result = await post(`${quotesUrl}/decline/${quoteNumber}`);
    return result;
}
